import { FreeDataVO as BaseFreeDataVO, EM_ACTION, IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { FreeData, FreeDataLevel, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { FreedataValueVO } from './freedatavalue.vo';
import { FreedataLevelVO } from './freedatalevel.vo';
import { FreedataArgsVO } from './freedataargs.vo';
import { Observable } from 'rxjs';
import { cloneDeep } from 'lodash-es';
import { WizTranslationManager } from '@wizeoo/akm-component-lib';
import { Model } from '../../model/model';
import { AttachmentService } from '../../command/core/attachment/attachment.service';
import { ViewData } from '../../model/view.data';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';

/**
 * VO free data
 */
@entity('wizeoo.allkeyme.core.message.FreeData', 'BU')
export class FreeDataVO extends BaseFreeDataVO implements IVo {

  constructor(model: Model, pSource?: FreeData) {
    super(model, pSource);
  }

  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }

  /** sur retour de service composite, remise à 0 des collections de VO (FDV et FDL) */
  public resetCollections(): void {
    // Appel au reset de collections contenu dans la classe de base
    super.resetCollections();

    this._levelsVO = null;
    this._allFieldsAsArgs = null;
  }

  /** clonage pour entrée d'EM */
  public cloneEM(): any {
    const clone: FreeData = cloneDeep(this.source);
    clone.freeDataValues = null;
    return clone;
  }

  public get id(): number {
    return this.source.id;
  }

  public set id(id: number) {
    this.source.id = id;
  }

  public get uid(): string {
    return this.source.uid;
  }
  public set uid(uid: string) {
    this.source.uid = uid;
  }

  /** Domaine */
  public set domain(domain: string) {
    this.source.domain = domain;
  }
  @field('string')
  public get domain(): string {
    return this.source.domain;
  }

  /** BU */
  public set businessUnitCode(businessUnitCode: string) {
    this.source.businessUnitCode = businessUnitCode;
  }
  @field('string')
  public get businessUnitCode(): string {
    return this.source.businessUnitCode;
  }

  /** Code */
  @field('string')
  public set code(code: string) {
    this.source.code = code;
  }
  public get code(): string {
    return this.source.code;
  }

  /** Code externe */
  @field('string')
  public set externalCode(code: string) {
    this.source.externalCode = code;
  }
  public get externalCode(): string {
    return this.source.externalCode;
  }

  /** Nom court */
  @field('string')
  public set shortCode(shortCode: string) {
    this.source.shortCode = shortCode;
  }
  public get shortCode(): string {
    return this.source.shortCode;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }

  public get operation(): string {
    return this.source.operation;
  }
  public set operation(value: string) {
    this.source.operation = value;
  }

  /** Date de début */
  @field('number')
  public set startDate(startDate: number | null) {
    this.source.startDate = startDate;
  }

  public get startDate(): number | null {
    return this.source.startDate;
  }

  /** Date de fin */
  @field('number')
  public set endDate(endDate: number | null) {
    this.source.endDate = endDate;
  }

  public get endDate(): number | null {
    return this.source.endDate;
  }

  @field('boolean')
  public get deprecated(): boolean {
    return this.source.deprecated;
  }
  public set deprecated(value: boolean) {
    this.source.deprecated = value;
  }

  /**  */
  public set chronoCode(code: string) {
    this.source.chronoCode = code;
  }

  public get chronoCode(): string {
    return this.source.chronoCode;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  @field('string')
  public set dataType(value: string) {
    this.source.dataType = value;
  }
  public get dataType(): string {
    return this.source.dataType;
  }




  @field('string')
  public get icon(): string {
    return this.source.icon;
  }

  public set icon(pValue: string) {
    this.source.icon = pValue;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  public toDie: boolean = false;

  /** Le free data est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.source.id > 0;
  }

  /** retourne l'icone si existe, sinon le média par défaut */
  public get iconOrDie(): Observable<string> {
    return AttachmentService.getInstance().iconOrDie(this.icon, this.domain, this.businessUnitCode, ViewData.wildcardMainVision);
    // return WizFileUtils.imageFromBinaryString(this.fileContent, RESOURCES.COMMON_UPLOAD);
  }

  /** compte le nombre d'éléments enfants */
  public get childrenCount(): number {
    return this.getValuesVO()?.length || 0;
  }

  /** affichage du nombre d'éléments */
  public get childrenCountLabel(): string {
    let res: string = this.getValuesVO()?.length.toString() || '0';
    res += ' ' + WizTranslationManager.getInstance().translateKey('$.common.item.$');
    return res;
  }


  /* ############################################
   *       Collecte/Construction des VOs
   * ############################################ */

  // [MOTEUR BACK] On récupére ici des instances "ihm"

  /** collecte des FDVos */
  public override getValuesVO(): FreedataValueVO[] {
    return super.getValuesVO() as FreedataValueVO[];
  }

  /** collecte d'un FDVvo par son code */
  public override getFreeDataValue(pCode: string): FreedataValueVO {
    return super.getFreeDataValue(pCode) as FreedataValueVO;
  }

  /** collecte des FDVos par code parent */
  public override getFreeDataValueByParent(parentCode: string): FreedataValueVO[] {
    return super.getFreeDataValueByParent(parentCode) as FreedataValueVO[];
  }

  /** collecte par shortCode */
  public override getFreeDataValueByShortCode(pShortCode: string): FreedataValueVO[] {
    return super.getFreeDataValueByShortCode(pShortCode) as FreedataValueVO[];
  }

  /** collecte des ArgsVO */
  public override getArgsVO(): FreedataArgsVO[] {
    return super.getArgsVO() as FreedataArgsVO[];
  }

  /** collecte des ArgsVO sous forme de Map */
  public override getArgsVOMap(): Map<string, FreedataArgsVO> {
    return super.getArgsVOMap() as Map<string, FreedataArgsVO>;
  }

  /* ################################################
              Gestion des values et levels
  ################################################ */

  /** ajout d'un FDV sur le Freedata */
  public addFreeDataValue(pValue: FreedataValueVO, endAction: boolean = false): void {
    super.addFreeDataValue(pValue);

    if (!endAction) {
      this.addToUpdatePack(pValue, EM_ACTION.CREATE); // ajout au pool de modifs
    }

  }

  /** suppression d'un FDV sur le Freedata */
  public removeFreeDataValue(toDelete: FreedataValueVO, endAction: boolean = false): void {
    super.removeFreeDataValue(toDelete);

    if (!endAction) {
      this.addToUpdatePack(toDelete, EM_ACTION.DELETE); // ajout au pool de modifs
    }
  }

  private _levelsVO: FreedataLevelVO[] = null; // liste de FDL encapsulés en VO

  public get levelsVO(): FreedataLevelVO[] {
    if (!this._levelsVO) {
      if (!this.source.freeDataLevels) {
        this.source.freeDataLevels = {};
      }
      this._levelsVO = Object.values(this.source.freeDataLevels).map((fdl: FreeDataLevel) => 
        this.model.freedataEngine.newFreedataLevelVO(fdl));
    }
    return this._levelsVO;
  }

  public get levelsVOMap(): Map<number, FreedataLevelVO> {
    // map des FDL par CODE (number, généré) {
    if (this.levelsVO) {
      return new Map(this.levelsVO.map((fdlvo: FreedataLevelVO) => [fdlvo.level, fdlvo]));
    }
    return null;
  }

  /* ################################################
              gestion de la traduction
  ################################################ */

  /**
   * Return translated label
   * @return string
   */
  public get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.shortCode);
  }

  /**
   * Return translated label
   * @return string
   */
  public get trsDescription(): string {
    return this.model.localeEngine.translate(this.description);
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /* ################################################
          gestion des arguments complémentaires
  ################################################ */

  private _allFieldsAsArgs: FreedataArgsVO[] = null;
  public get allFieldsAsArgs(): FreedataArgsVO[] {
    if (!this._allFieldsAsArgs) {
      this._allFieldsAsArgs = [];
      this._allFieldsAsArgs = this._allFieldsAsArgs.concat(this.model.freedataEngine.buildBasicArgs(this.code));
      this._allFieldsAsArgs = this._allFieldsAsArgs.concat(this.getArgsVO());
    }
    return this._allFieldsAsArgs;
  }

  /** ajout d'un arg le Freedata */
  public addArg(pValue: FreedataArgsVO): void {
    this.argsVO.push(pValue);
    this.allFieldsAsArgs.push(pValue);

    this.argsVOMap?.set(pValue.code, pValue);
    if (!this.source.args) {
      this.source.args = {};
    }
    this.source.args[pValue.code] = pValue.source;
  }

  /** suppression d'un arg sur le Freedata */
  public removeArg(toDelete: FreedataArgsVO): void {
    const index: number = this.argsVO.indexOf(toDelete);
    if (index >= 0) {
      this.argsVO.splice(index, 1);
      this.argsVOMap?.delete(toDelete.code);
    }

    if (this._allFieldsAsArgs) {
      const indexAllFields: number = this._allFieldsAsArgs.indexOf(toDelete);
      if (indexAllFields >= 0) {
        this._allFieldsAsArgs.splice(indexAllFields, 1);
      }
    }

    delete this.source.args[toDelete.source.code];
    // et suppression de la source
    // index = this.source.args.indexOf(toDelete.source);
    // if (index >= 0) {
    //   this.source.args.splice(index, 1);
    // }
  }



  /* ################################################
              update sélectif des FDVs
  ################################################ */

  /**
   * ajout des FDVs modifiés pour update sélectif (grosses collections)
   *
   * @param fdv à ajouter
   * @param op crud
   */
  public addToUpdatePack(fdv: FreedataValueVO, op: EM_ACTION): void {
    // const exist: [FreedataValueVO, string] = this._updateMap.get(fdv?.code);
    const exist: [any, string] = this._updateMap.get(fdv?.code);
    if (exist) {
      const status: string = exist[1];
      if (op === EM_ACTION.DELETE) {
        // la suppression, c'est plus fort que tout
        if (exist[0].exist) { // c'est un FDV persisté
          this._updateMap.set(fdv.code, [fdv, op]);
        } else { // suppression d'une création
          this._updateMap.delete(fdv.code);
        }

      } else {
        // forcément UPDATE
        if (status === EM_ACTION.CREATE) {
          // rien, le create est plus fort que l'update
        } else {
          this._updateMap.set(fdv.code, [fdv, op]); // normalement, sert à rien. Le FDV est déjà mappé, même statut
        }
      }
    } else {
      // pas dedans, simple
      this._updateMap.set(fdv.code, [fdv, op]);
    }
  }

}
